import { TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import React from 'react';
import { v4 as uuid } from 'uuid';
import { EnhancedTableProps } from './type';

export function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, columns, autoIndex } = props;

  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const visibleColumns = columns.filter((column) => column.visible !== false);

  return (
    <TableHeader>
      <TableRow className="bg-gray-50 hover:bg-gray-50">
        {autoIndex ? (
          <TableHead
            key={uuid()}
            className="font-semibold text-gray-900 text-center min-w-[60px] w-[60px]"
          >
            #
          </TableHead>
        ) : null}
        {visibleColumns.map((headCell) => {
          const isActive = orderBy === headCell.id;
          const align = headCell.align || 'left';
          const alignClass =
            align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

          return (
            <TableHead key={uuid()} className={`font-semibold text-gray-900 ${alignClass}`}>
              {headCell.id && headCell.orderable ? (
                <button
                  onClick={createSortHandler(headCell.id!)}
                  className="flex items-center gap-1 hover:text-gray-900 transition-colors"
                >
                  <span>{headCell.label}</span>
                  {isActive ? (
                    order === 'asc' ? (
                      <ArrowUp className="h-4 w-4 text-blue-600" />
                    ) : (
                      <ArrowDown className="h-4 w-4 text-blue-600" />
                    )
                  ) : (
                    <ArrowUpDown className="h-4 w-4 opacity-50" />
                  )}
                </button>
              ) : (
                <span>{headCell.label}</span>
              )}
            </TableHead>
          );
        })}
      </TableRow>
    </TableHeader>
  );
}
